export const logger = {
    log: function (value) {
        if (!PRODUCTION)
            console.log(value);
    },
    error: function (value) {
        if (!PRODUCTION)
            console.error(value);
    }
}